import "./main_dashboard.css";
import Top_navbar from "./Top_navbar";
import { notification, Skeleton } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-regular-svg-icons';

import { useNavigate } from "react-router-dom";
import { faCircleCheck, faCircleInfo, faSync } from "@fortawesome/free-solid-svg-icons";
import { syncRechargePlans } from "../../controllers/common";
import { useState } from "react";
const Dashboard = () => {
 const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false); 
  const handleSyncRechargePlans = async () => {
    try {
      if(isLoading === false){
        setLoading(true);
        const res = await syncRechargePlans();
        if(res === true){
          notification.open({
            message: "Success",
            description: `Recharge plans is sync now.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCircleCheck} style={{ color: "green" }} />,
            duration: 2,
          });
        } else{
          notification.open({
            message: "Oops!",
            description: `Please try after some time.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCircleInfo} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
        setLoading(false);
      console.log('error : ', error);
    } finally {
      setLoading(false);
    }
  }

  
  return (
    <>
      <Top_navbar></Top_navbar>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3 px-0" onClick={handleSyncRechargePlans}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}> 
                  {isLoading ? (
                    `Loading...`
                  ) : (
                    <FontAwesomeIcon icon={faSync} className="sidebar_collapse_iohomeoutline" />
                  )}
                </span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Sync Recharge Data</h1>
                </div>
                <p className="presentation my-2">
                  Sync recharge plans, provider and country from Ding Connect Portal.
                </p>
              </div>
            </div>
          </div>

        </div>
        <hr/>
        <div className="row">
          
          <div className="col-md-3 px-0" onClick={()=>navigate('/customers-due/list')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Customer's Due</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to customer's due list
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-3 px-0" onClick={()=>navigate('/invoice/list')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Individual Invoice</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to individual invoice list
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-3 px-0"onClick={()=>navigate('/invoice/request')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Bulk Invoice request</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to bulk invoice request list
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-3 px-0"onClick={()=>navigate('/transaction')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Transaction</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to bulk invoice request list
                </p>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    </>
  );
};

export default Dashboard;
